module.exports = __webpack_public_path__ + "static/media/digital-retouching.c25b52e9.svg";